function validateAllReferences($refs) {
	let isValid = true;
	if ($refs) {
		for (const key in $refs) {
			const ref = $refs[key];
			const isArray = Array.isArray(ref);

			if (isArray) {
				isValid = validateAllReferences(ref) && isValid;
			} else if (ref && ref.validate) {
				isValid = ref.validate() && isValid;
			}
		}
	}
	return isValid;
}

export default {
	methods: {
		validate: function() {
			return validateAllReferences(this.$refs);
		},
	},
};
